import { useState } from 'react';

/* 🔥 Normalize downloadData before sending to backend */
const normalizeDownloadData = (data) => {
  if (!data) return [];

  // If already array → OK
  if (Array.isArray(data)) return data;

  // If string → try parse
  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      return [];
    }
  }

  // If object → wrap into array
  if (typeof data === "object") {
    return [data];
  }

  return [];
};

const useAIInsights = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateAIInsights = async (params) => {
    setIsLoading(true);
    setError(null);

    try {
      const requestBody = {
        downloadData: normalizeDownloadData(params.downloadData),  // 🔥 FIX HERE
        radioButtonState: params.radioButtonState || {},
        kpiName: params.kpiName,
        chartType: params.chartType || "Bar",
        vinShort: params.vinShort
      };

      console.log("🚀 Sending AI insights request:", requestBody);

      // Determine base URL based on hostname (same pattern as useDropdownData)
      let baseURL;
      if (window.location.hostname === "simbaanalytics-dev.rio.cloud") {
        baseURL = "https://26ovsbph5oz6xpn2fgscmr5x5i0socao.lambda-url.eu-west-1.on.aws";
      } else if (window.location.hostname === "bev-dev.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://spv3toxlwj.execute-api.eu-west-1.amazonaws.com/test_cognito";
      } else if (window.location.hostname === "bev-prod.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://dnz0zln7l2.execute-api.eu-west-1.amazonaws.com/prod";
      } else {
        baseURL = "http://localhost:8080";
      }

      // Get token from localStorage for authentication
      const token = localStorage.getItem("idToken");

      // Set up headers with Bearer token
      const headers = {
        'Content-Type': 'application/json',
      };

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(
        `${baseURL}/api/generate-ai-insights`,
        {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || `HTTP error ${response.status}`);
      }

      console.log("✅ AI insights response:", data);

      if (data.success) {
        return data.aiInsights;
      } else {
        throw new Error(data.error || 'Failed to generate AI insights');
      }

    } catch (err) {
      console.error("❌ AI insights generation failed:", err);
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    generateAIInsights,
    isLoading,
    error,
  };
};

export default useAIInsights;
